import React from 'react';

const EVENT_SHOW = 'submitting-overlay:show';
const EVENT_HIDE = 'submitting-overlay:hide';

export function showSubmittingOverlay(text = 'Enviando, aguarde...') {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT_SHOW, { detail: { text } }));
  }
}

export function hideSubmittingOverlay() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT_HIDE));
  }
}

const SubmittingOverlay: React.FC = () => {
  const [visible, setVisible] = React.useState(false);
  const [text, setText] = React.useState('Enviando, aguarde...');

  React.useEffect(() => {
    const onShow = (e: Event) => {
      const ce = e as CustomEvent<{ text?: string }>;
      setText(ce.detail?.text || 'Enviando, aguarde...');
      setVisible(true);
    };
    const onHide = () => setVisible(false);

    window.addEventListener(EVENT_SHOW, onShow as EventListener);
    window.addEventListener(EVENT_HIDE, onHide as EventListener);
    return () => {
      window.removeEventListener(EVENT_SHOW, onShow as EventListener);
      window.removeEventListener(EVENT_HIDE, onHide as EventListener);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl px-6 py-5 flex items-center gap-3">
        <svg className="animate-spin h-5 w-5 text-primary-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
        <span className="text-sm text-gray-800">{text}</span>
      </div>
    </div>
  );
};

export default SubmittingOverlay;
